// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent---RZGHn","modalFooter":"modalFooter---P_abD"};